import angular from 'angular';
import _ from 'lodash';
import 'angular-sanitize';

import yesNoModalDirective from './yesNoModal.directive';

export default angular.module('fp:customerportal:common:dialog', ['ngSanitize'])
    .constant('_', _)
    .directive('fpYesNoModal', yesNoModalDirective);